/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index global-status to autogenerate all the components and extensions
 * Used by "prepareGlobalStatuss"
 */

import GlobalStatus from './global-status/GlobalStatus'
export * from './global-status/GlobalStatus'
export default GlobalStatus
